export const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
export const REFRESH_TOKEN_EXPIRY_STORAGE_KEY = 'REFRESH_TOKEN_EXPIRY';
export const CURRENT_USER_FULLNAME_KEY = 'CURRENT_USER_FULLNAME_KEY';
